import { subscribePushState } from './subscribePushState';
import { pageScrollTop } from './pageScrollTop';
export function autoScrollTop({ onPushState, onReloadPage, }) {
    const unsubscribers = [];
    if (onPushState) {
        unsubscribers.push(subscribePushState((data, title, url) => {
            if (url) {
                pageScrollTop();
            }
        }));
    }
    if (onReloadPage) {
        const beforeunload = () => {
            pageScrollTop();
        };
        window.addEventListener('beforeunload', beforeunload);
        unsubscribers.push(() => {
            window.removeEventListener('beforeunload', beforeunload);
        });
    }
    return () => {
        unsubscribers.forEach(unsubscribe => unsubscribe());
        unsubscribers.length = 0;
    };
}
